import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  limit
} from "firebase/firestore";
import { firestore } from "../firebase";
import { TrackData } from "../types/Types";

export interface ArtistProfileData {
  userId: string;
  userName: string;
  artistName: string;
  avatarUrl: string;
  stateID: number;
  stateName: string;
}

export const ArtistService = {

  fetchArtistData: async (userNameParam: string) => {
    try {
      const usersRef = collection(firestore, "users");
      const q = query(usersRef, where("userName", "==", userNameParam), limit(1));
      const userSnap = await getDocs(q);

      if (userSnap.empty) {
        console.warn(`No user found with userName: ${userNameParam}`);
        return null;
      }

      const userDoc = userSnap.docs[0];
      const userData = userDoc.data();
      const userId = userDoc.id;

      const userStateID = typeof userData.stateID === 'number' ? userData.stateID : 0;

      let stateName = "Unknown State";

      if (userStateID > 0) {
        try {
          const statesRef = collection(firestore, "stateCharts");
          const stateQ = query(statesRef, where("stateID", "==", userStateID), limit(1));
          const stateSnap = await getDocs(stateQ);

          if (!stateSnap.empty) {
            const stateData = stateSnap.docs[0].data();
            stateName = stateData.stateName || "Unknown State";
          }
        } catch (err) {
          console.error("Error fetching state name:", err);
        }
      }

      const profile: ArtistProfileData = {
        userId: userId,
        userName: userData.userName || userNameParam,
        artistName: userData.artistName || "Artist",
        avatarUrl: userData.avatarUrl || userData.profileImage || "https://via.placeholder.com/150",
        stateID: userStateID,
        stateName: stateName
      };

      const tracksRef = collection(firestore, "trackLinks");
      const tracksQ = query(
        tracksRef,
        where("userId", "==", userId),
        orderBy("releaseDate", "desc")
      );

      const tracksSnap = await getDocs(tracksQ);

      const tracks: TrackData[] = tracksSnap.docs.map(doc => {
        const t = doc.data();
        return {
          id: doc.id,
          userId: t.userId,
          userName: profile.userName,
          stateID: t.stateID,
          regionID: t.regionID,
          coverArtUrl: t.coverArtUrl,
          trackTitle: t.trackTitle,
          artistName: t.artistName,
          featureArtists: t.featureArtists,
          genreName: t.genre,
          releaseType: t.releaseType,
          platformLinks: t.platformLinks,
          moodTags: t.moodTags,
          releaseDate: t.releaseDate
        };
      });

      return { profile, tracks };

    } catch (error) {
      console.error("Error fetching artist profile:", error);
      return null;
    }
  }
};